module.exports = __webpack_public_path__ + "media/images/icons/warning-5f2e8f01f04c9f24c81f7be3a17fd6aa.png";